import en from './en';

export const validationTranslations: NamespaceTranslations<keyof typeof en> = {
  en,
};
